export default __webpack_public_path__ + "static/media/0xa07ac8cde2a98b189477b8e41f0c2ea6cddbc055.03235c32.png";